import {HibuUiConfiguration, TagOptions} from './config-types';

type ConfigLoadedAction = {
    readonly type: 'CONFIG_LOAD_FINISHED';
    readonly config:  HibuUiConfiguration;
} | {
    readonly type: 'CONFIG_LOAD_TAG_OPTIONS_FINISHED';
    readonly tagOptions: TagOptions;
};

export type ConfigAction = ConfigLoadedAction;

export const configLoaded = (data: HibuUiConfiguration): ConfigLoadedAction => {
    return {
        type: 'CONFIG_LOAD_FINISHED',
        config: data
    };
};

export const configTagOptionLoaded = (data: TagOptions): ConfigLoadedAction => {
    return {
        type: 'CONFIG_LOAD_TAG_OPTIONS_FINISHED',
        tagOptions: data
    };
};
